import React from 'react';

// Marcadores de posición del tamaño exacto del contenido final. Sin ellos la
// página aparece vacía y luego todo salta de sitio cuando llegan los datos;
// con ellos se percibe más rápida aunque tarde lo mismo.

export const EsqueletoTarjeta = () => (
  <div className="ed-tarjeta" aria-hidden="true">
    <div className="ed-esqueleto ed-esqueleto--foto" />
    <div className="ed-esqueleto ed-esqueleto--titulo" />
    <div className="ed-esqueleto ed-esqueleto--titulo-corto" />
  </div>
);

export const EsqueletoListado = ({ filas = 5 }) => (
  <ul className="ed-list" aria-hidden="true">
    {Array.from({ length: filas }).map((_, i) => (
      <li key={i} className="ed-list__item">
        <div className="ed-esqueleto" style={{ width: 96, height: 72 }} />
        <div>
          <div className="ed-esqueleto ed-esqueleto--linea" />
          <div className="ed-esqueleto ed-esqueleto--linea-corta" />
        </div>
      </li>
    ))}
  </ul>
);

export const EsqueletoPortada = () => (
  <div className="ed-shell ed-esqueleto-hero" aria-busy="true" aria-label="Cargando portada">
    <div className="ed-grid">
      <div>
        <div className="ed-esqueleto ed-esqueleto--foto" />
        <div className="ed-esqueleto ed-esqueleto--titulo" style={{ height: '2.6rem', margin: '1.5rem auto 0.75rem', maxWidth: '70%' }} />
        <div className="ed-esqueleto ed-esqueleto--linea-corta" style={{ margin: '0 auto' }} />
      </div>
      <aside className="ed-aside">
        <div className="ed-esqueleto ed-esqueleto--titulo" style={{ width: '55%' }} />
        <EsqueletoListado filas={4} />
      </aside>
    </div>
  </div>
);

export const EsqueletoArticulo = () => (
  <div className="news-section" aria-busy="true" aria-label="Cargando noticia">
    <div className="content">
      <div className="ed-esqueleto ed-esqueleto--linea-corta" style={{ margin: '0 auto 1rem' }} />
      <div className="ed-esqueleto ed-esqueleto--titulo" style={{ height: '2.4rem', marginBottom: '0.6rem' }} />
      <div className="ed-esqueleto ed-esqueleto--titulo" style={{ height: '2.4rem', width: '75%', margin: '0 auto 1.5rem' }} />
      <div className="ed-esqueleto ed-esqueleto--foto" style={{ marginBottom: '2rem' }} />
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="ed-esqueleto ed-esqueleto--linea"
          style={{ width: i % 3 === 2 ? '80%' : '100%' }}
        />
      ))}
    </div>
  </div>
);
